import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/ideas/[id]/IdeaPage.tsx");
